export default __webpack_public_path__ + "static/media/rtl_student_devices_mockup.3d613ebb.png";